import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook.tsx';
import { queryKeys } from '@queries/keys.ts';
import { useQuery } from '@tanstack/react-query';
import { DigitalIntegrationSelectDto, DigitalIntegrationsSelectDto } from '../types/api.types';

export const useGetDigitalIntegrations = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<DigitalIntegrationSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<DigitalIntegrationsSelectDto>({
        path: '/v1/data/digital-integrations',
      });
      return result.digitalIntegrations;
    },
    queryKey: enabled ? queryKeys.digitalIntegration.getDigitalIntegrations : queryKeys.placeholders.default,
  });
};
